import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RTQAssessmentsFolderableCollectionService } from 'RTQApp/services/rtq-assessments-folderable-collection-ajax.service';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import * as i0 from "@angular/core";
export class StartRTQAssessmentModalModule {
}
StartRTQAssessmentModalModule.ɵfac = function StartRTQAssessmentModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StartRTQAssessmentModalModule)(); };
StartRTQAssessmentModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: StartRTQAssessmentModalModule });
StartRTQAssessmentModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [RTQAssessmentsFolderableCollectionService], imports: [BaseAutocompleteModule,
        CommonModule,
        FormsModule,
        IconModule,
        IsSharedWithOthersPipeModule,
        ModalBaseModule,
        TooltipModule] });
